import { Grid } from '@material-ui/core';
import { Page, Header, Content } from '@backstage/core-components';
import { HomePageCompanyLogo } from '@backstage/plugin-home';
import { OverviewCard } from './OverviewCard';
import { LinksCard } from './LinkCard';
import { DeploymentsCard } from './DeploymentsCard';

export const HomePage = () => {
    return (
        <Page themeId="home">
            <Header title="SITECORE - HOME" subtitle={<HomePageCompanyLogo />} />
            <Content>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <OverviewCard />
                    </Grid>                   
                    <Grid item xs={12} md={6}>
                    <LinksCard />
                    </Grid>
                    <Grid item xs={12}>
                        <DeploymentsCard />
                    </Grid>
                </Grid>
            </Content>
        </Page>
    );
};